import React from "react";
import "./onlineTraining.css";
import "../../../page-layout.css";
import onlineImage from "../../images/online-trening1.jpeg";
import { Helmet } from "react-helmet";

const features = [
  "Personalizovan plan i program treninga",
  "Pravilno izvođenje vežbi s opisom tehnike",
  "Povratne informacije (tekst, video)",
  "Vizuelno praćenje napretka kroz slike",
  "Plan ishrane i suplementacija (gratis)",
  "Stalna motivacija i podrška",
];

export default function OnlineTraining() {
  return (
    <div className="page-wrap">
      <Helmet>
        <title>Online trening | Mihailo Živanović</title>
        <meta
          name="description"
          content="Online trening — sve prednosti 1 na 1 treninga, dostupno kad god i gde god se nalaziš."
        />
      </Helmet>

      <div className="page-hero">
        <div className="page-hero-inner">
          <div className="page-hero-eyebrow">Usluge</div>
          <h1 className="page-hero-title">ONLINE TRENING</h1>
          <p className="page-hero-desc">
            Sve prednosti personalnog treninga — dostupno online, kad god i gde
            god se nalaziš. Idealno za one koji ne mogu biti u teretani.
          </p>
        </div>
      </div>

      <div className="service-body">
        <div className="service-inner">
          <div className="service-text-col">
            <div className="service-section">
              <div className="section-eyebrow">O usluzi</div>
              <p className="service-p">
                Online trening je sve ono što bi bilo u praksi 1 na 1, samo
                je online — kroz vođenje i praćenje procesa sve vreme.
                Podrazumeva međusobnu interakciju između trenera i klijenta.
              </p>
              <p className="service-p">
                Idealan za one koji žive u drugom gradu ili državi, ili koji
                ne mogu da priušte trenera uživo. Prilagodljiv po terminu —
                jutarnji, popodnevni ili večernji, koliko god puta nedeljno.
              </p>
              <p className="service-p">
                Tu sam da ti prenesem iskustvo i da te upoznam sa sobom onako
                kako se još sami niste upoznali — kada su forma i zdrave
                životne navike u pitanju.
              </p>
            </div>

            <div className="service-section">
              <div className="section-eyebrow">Šta uključuje</div>
              <ul className="service-feature-list">
                {features.map((f) => (
                  <li key={f}>
                    <span className="feature-dot" />
                    {f}
                  </li>
                ))}
              </ul>
            </div>

            <div className="service-price-box">
              <span className="service-price-label">Cena</span>
              <span className="service-price-value">Na upit</span>
              <p className="service-price-note">
                Cena zavisi od učestalosti i trajanja programa. Pošalji upit.
              </p>
            </div>
          </div>

          <div className="service-img-col">
            <div className="service-img-wrap">
              <img src={onlineImage} alt="Online trening" />
            </div>

            <div className="service-cta-box">
              <h3>Počni danas</h3>
              <p>Zakaži besplatne konsultacije i kreni ka svom cilju.</p>
              <a href="/kontakt/" className="service-cta-btn">Zakaži trening</a>
              <a href="tel:+381600737363" className="service-tel-link">
                +381 60 073 7363
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="page-cta-strip">
        <div className="page-cta-strip-inner">
          <h2>SPREMAN ZA ONLINE TRENING?</h2>
          <div className="page-cta-strip-actions">
            <a href="/kontakt/" className="btn-dark">Zakaži trening</a>
            <a href="tel:+381600737363" className="btn-outline">Pozovi me</a>
          </div>
        </div>
      </div>
    </div>
  );
}
